import { History } from "lucide-react";
import { fechaCorta } from "@/lib/migracion";

// Perfil 360 › Créditos: aviso de los créditos que llegaron de otro sistema (individual o por Excel).
export function AvisoCreditoMigrado({ creditos }) {
  const migrados = (creditos || []).filter((c) => c.cartera_migrada);
  if (!migrados.length) return null;
  return (
    <div className="space-y-1.5" data-testid="c360-avisos-credito-migrado">
      {migrados.map((c) => (
        <div key={c.id} data-testid={`c360-aviso-credito-migrado-${c.id}`}
          className="flex items-start gap-2 rounded-md border border-indigo-200 bg-indigo-50/60 px-3 py-2 text-sm text-indigo-950">
          <History className="mt-0.5 h-4 w-4 shrink-0 text-indigo-500" />
          <span>
            <b className="font-mono">{c.numero_credito}</b>: Crédito migrado de otro sistema el{" "}
            {fechaCorta(c.migracion?.fecha_original || c.fecha_disposicion)}; número anterior {c.numero_credito_anterior || "—"}.
            {c.migracion_excel && <span className="text-indigo-700"> Cargado por Excel (lote {c.migracion_lote_id}), autorizado por migración.</span>}
            {c.corregido_por_migracion && (
              <span className="text-indigo-700"> Corregido por migración inicial el {fechaCorta(c.correccion_fecha)} (condiciones anteriores en bitácora).</span>
            )}
          </span>
        </div>
      ))}
    </div>
  );
}
